export class ConfigService {
  CARILOOP_URL: string;
  FACEBOOK_APP_ID: string;
  GOOGLE_APP_ID: string;
  KINSIDE_URL: string;
  SERVER_URL: string;
  STRIPE_KEY: string;
  RECAPTCHA_KEY: string;

  constructor() {
    this.CARILOOP_URL = process.env.REACT_APP_CARILOOP_URL ?? '';
    this.FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID ?? '';
    this.GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID ?? '';
    this.KINSIDE_URL = process.env.REACT_APP_KINSIDE_URL ?? '';
    this.SERVER_URL = process.env.REACT_APP_SERVER_URL ?? '';
    this.STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY ?? '';
    this.RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY ?? '';
  }
}
